import React from 'react'

type PlanStepsContextType = {
  turnId: string
  enableAnimation: boolean
  expandedStepIds: Set<string>
  setExpandedStepIds: (updater: (prev: Set<string>) => Set<string>) => void
}

export const PlanStepsContext = React.createContext<PlanStepsContextType | null>(null)

export const PlanStepsProvider: React.FC<{
  children: React.ReactNode
  value: PlanStepsContextType
}> = ({ children, value }) => (
  <PlanStepsContext.Provider value={value}>{children}</PlanStepsContext.Provider>
)

export const usePlanStepsContext = () => {
  const context = React.useContext(PlanStepsContext)
  if (!context) {
    throw new Error('usePlanStepsContext must be used within a PlanStepsProvider')
  }
  return context
}
